<template>
	<div class="m-1">
		<b-modal ref="publish-modal" size="mg" id="modal-center" centered hide-footer
			title="还款申请">
			<div>
				<b-form>
					<b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-sm   
						content-cols-lg="8" class=""  label="姓名:"
						label-for="input-horizontal">
						<b-form-input id="input-1" v-model="form.userName" type="email" placeholder="" disabled>
						</b-form-input>
					</b-form-group>
					<b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-sm
						content-cols-lg="8"  label="证件号码:"
						label-for="input-horizontal">
						<b-form-input id="input-2" v-model="form.userIdNoMask" placeholder="" disabled></b-form-input>
					</b-form-group>

					<div v-if="hasCards==0" class="pb-1 pt-1">
						<b>您还未绑定银行卡</b> <a href="#" @click="addCard" class="ml-3">添加银行卡</a>
						<!-- <a href="#" @click="banklist" class="ml-3">支持的银行</a> -->
					</div>

					<div v-else-if="hasCards==1">
						<a href="#" @click="addCard" class="ml-5">添加银行卡</a>
						<!-- <a href="#" @click="banklist" class="ml-3">支持的银行</a> -->
					</div>
					<div v-else-if="hasCards>1">
						<a href="#" @click="addCard">添加银行卡</a> <a href="#" @click="mycardlist">选择银行卡</a>
						<!-- <a href="#" @click="banklist" class="ml-3">支持的银行</a> -->
					</div>
					<div v-if="hasCards>0">
						<b-form-group id="fieldset-horizontal" label-cols-sm="3" label-cols-lg="3" content-cols-sm
							content-cols-lg="8"  label="银行卡号:"
							label-for="input-horizontal">
							<b-form-input id="input-2" v-model="form.cardNo" placeholder="" disabled></b-form-input>
						</b-form-group>
						
					<!-- 	<b-form-group id="fieldset-horizontal" label-cols-sm="3" label-cols-lg="3" content-cols-sm
							content-cols-lg="8"  label="银行名称:"
							label-for="input-horizontal">
							<b-form-input id="input-2" v-model="form.bankName" placeholder="" disabled></b-form-input>
						</b-form-group> -->
						
						<div v-for="(item, index) in LoanList" :key="index" class="border-top pt-1">
							<b-form-group id="fieldset-horizontal" label-cols-sm="3" label-cols-lg="3" content-cols-sm
								content-cols-lg="8"  label="合同号:"
								label-for="input-horizontal">
								<b-form-input id="input-loanno" :value="item.loanContractNo" placeholder="" disabled></b-form-input>
							</b-form-group>
							<b-form-group id="fieldset-horizontal" label-cols-sm="3" label-cols-lg="3" content-cols-sm
								content-cols-lg="8"  label="应还金额:"
								label-for="input-horizontal">
								<b-form-input id="input-torepay" :value="item.totalRepyaAmount/100" placeholder="" disabled></b-form-input>
							</b-form-group>
							
							<b-form-group id="fieldset-horizontal" label-cols-sm="3" label-cols-lg="3" content-cols-sm
								content-cols-lg="8"  label="还款金额:"
								label-for="input-horizontal">
								<b-form-input id="input-repay"  placeholder="输入还款金额" type="number" min="0.01" max="100000.00"
									v-model="repayInput[index]"	required>
								</b-form-input>
								<div @click="copyInput(item.totalRepyaAmount/100,index)" class="text-primary" role="button"
									style="position: absolute;top:10%;right:10%; text-decoration: underline;">填入应还金额</div>
							</b-form-group>
						</div>
						
						<b-form-group id="input-group-2" label="短信验证码:" label-for="input-2">
							<div class="d-flex justify-content-between">
								<b-form-input id="input-2" v-model="form.smscode" placeholder="输入短信验证码" class="w-50" ref="input">
								</b-form-input>
						
								<b-input-group-append style="font-size: 10px;">
									<b-button variant="outline-success" @click="preConfirmPay" v-if="ts==180">获取验证码</b-button>
									<b-button variant="outline-secondary" class="" v-else>{{ts}}秒后再获取</b-button>
								</b-input-group-append>
							</div>
						</b-form-group>
						
					</div>
				</b-form>
				
				<b-overlay :show="showWaiting" rounded="sm" style="font-size: 90%;text-align: center;" class="p-1">
					<span v-if="showWaiting"  class="text-primary">正在等待支付处理结果...</span>
				</b-overlay>	
				<div class="d-flex justify-content-end mr-3 mt-3" v-if="hasCards>0">
					<b-button  variant="secondary" class="ml-3" @click="hideModal"> 取消</b-button>
					<b-button  variant="success" class="ml-3" @click="confirmPay" v-if="preConfirm">确认支付 </b-button>
				</div>
				
			</div>
			<CardListModal ref="cardModal"></CardListModal>
			<AddCardModal ref="addcardModal"></AddCardModal>
			<BankListModal ref="bankListModal"></BankListModal>
			<ReductModal ref="reductModal"></ReductModal>
			<WaitingModal ref="waitingModal"></WaitingModal>
		</b-modal>
	</div>
</template>
<script>
	import CardListModal from './CardListModal.vue';
	import AddCardModal from './AddCardModal.vue';
	import BankListModal from './BankListModal.vue';
	import ReductModal from './ReductModal.vue';
	import WaitingModal from './WaitingModal.vue';
	export default {
		components: {
			CardListModal,
			AddCardModal,
			BankListModal,
			ReductModal,
			WaitingModal
		},
		data() {
			return {
				form: {
					cardNo: '',
					bankName: '',
					userName: '',
					amount: 100,
					userIdNo: "",
					userIdNoMask: "",
					linkId: "",
					phone:"",
					smscode:"",
					totalAmount: 0,
				},
				ts: 180,
				maxSecond: 180,
				hasCards: 0,
				smsTimer: 0,
				cardList: [],
				crfUid: "",
				cardIndex: 0,
				loanNo: "",
				LoanList:null,
				repayInput:[],
				requestNo:"",
				showWaiting:false,
				waitTimer:0,
				timeOut:0,
				reductAmt: 0,
				repayInfo: null,
				openid: "",
				netRepay: 0,
				totalRepay: 0,
				fundSource:"",
				channelNo:"",
				requestRefNo:"",
				preConfirm:false,
			}
		},

		methods: {
			banklist() {
				this.$refs['bankListModal'].showModal()
			},
			
			mycardlist() {
				this.$refs['cardModal'].showModal(this.cardList, this.setcard,"sxy")
			},

			setcard(_index) {
				let that = this;
				//that.form.bankName = that.cardList[_index].bankName
				that.form.cardNo = that.cardList[_index].bankCardNo
				that.form.linkId = that.cardList[_index].linkId
			},

			refreshcard() {
				this.bindList(this.crfUid)
			},
			
			waitResult(refNo){
				let that = this;
				let _openid = localStorage.getItem("_openid")
				this.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/payResult/" + refNo, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						console.log("payResult--->response====>",response)
						if(response.data.result=="FAIL"){
							that.toast("还款支付失败:"+response.data.failReason)
							that.showWaiting=false
							clearInterval(that.waitTimer)
						} else if (response.data.result=="SUCCESS"){
							that.toast("还款支付成功")
							that.showWaiting=false
							clearInterval(that.waitTimer)
							that.hideModal()
							//that.$parent.getLoanList()
						} else{
							if(that.timeOut>9){
								that.toast("还款支付中,请稍后查询支付结果.")
								that.showWaiting=false
								clearInterval(that.waitTimer)
								//that.$parent.getLoanList()
								that.hideModal()
							}else{
								that.timeOut++
							}
							that.showWaiting=true;
						}
					})
					.catch(function(error) {
						console.log(error)
				});
			},
			
		
			showModal(userIdNo, userName, crfUid, totalAmount,loanList,reductAmt,fundSource,channelNo) {
				this.form.userIdNo=userIdNo;
				this.form.userName = userName;
				const start = userIdNo.slice(0, 4);
				const end = userIdNo.slice(-4);
				const maskedPart = '*'.repeat(userIdNo.length - 8);
				this.form.userIdNoMask = start+maskedPart+end;
				
				this.crfUid = crfUid;
				this.form.totalAmount = totalAmount;
				this.LoanList=loanList;
				this.repayInput=[];
				this.ts=180;
				this.form.phone=""
				this.form.smscode=""
				this.requestRefNo=""
				this.waitTimer=0;
				this.showWaiting=false;
				this.reductAmt = reductAmt;
				this.channelNo=channelNo;
				this.fundSource=fundSource
				this.preConfirm=false;

				
				if(this.smsTimer>0){
					clearInterval(this.smsTimer)
				}
				if(this.waitTimer>0){
					clearInterval(this.waitTimer)
				}
				this.$refs['publish-modal'].show()
				this.bindList(this.crfUid)
			},
			
			validateUSPhoneNumber(phoneNumber) {
				// 创建一个正则表达式
				const phoneRegex = /^1[3-9]\d{9}$/;
				return phoneRegex.test(phoneNumber);
			},
			
			reduct(repayInfo, _openid, netRepay, reductAmt, totalRepay) {
				this.$refs['reductModal'].showModal(repayInfo, _openid, netRepay, reductAmt, totalRepay,"",this.getRefNo)
			},
			
			callBack() {
				this.reduct(this.repayInfo, this.openid, this.netRepay, this.reductAmt, this.totalRepay)
			},
			
			getRefNo(_no){
				this.preConfirm=true;
				this.requestRefNo=_no;
			},
			
			copyInput(_val,_index){
				this.repayInput[_index]=_val;
				this.$forceUpdate()
			},
			
			goPay() {
				let that = this;
				const unixTimestamp = Math.floor(Date.now() / 1000);
				let _lastime = localStorage.getItem("_lastime")
				if (_lastime != null) {
					let tn = unixTimestamp - _lastime
					if (tn < that.maxSecond) {
						that.$refs['waitingModal'].showModal(that.maxSecond-tn, this.callBack)
						return
					}
				}
				this.callBack()
			},
			
			formatCurrency(value) {
				if (!value) return '0.00';
				return new Intl.NumberFormat('zh-CN', { style: 'currency', currency: 'CNY' }).format(value);
			},

			addCard() {
				this.$refs['addcardModal'].showModal(this.form.userName, this.form.userIdNo,this.form.userIdNoMask, this.refreshcard,'sxy')
			},

			hideModal() {
				this.$refs['publish-modal'].hide()
			},

			toast(toaster, append = false) {
				this.$bvToast.toast(toaster, {
					title: `提示`,
					toaster: "b-toaster-top-center",
					solid: true,
					variant: "danger",
					appendToast: append
				})
			},

			bindList(crfUid) {
				let that = this;
				let _openid = localStorage.getItem("_openid")
				this.$axios.get(that.$DOMAIN() + "/wechatApi/payease/queryCardList/" + crfUid, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						console.log(response.data.data)
						that.hasCards = response.data.data.length
						if (that.hasCards > 0) {
							that.form.bankName = response.data.data[0].bankName
							that.form.cardNo = response.data.data[0].bankCardNo
							that.form.linkId = response.data.data[0].linkId
							that.cardList = response.data.data;
						}
					})
					.catch(function(error) {
						console.log(error)
					});
			},
			
			confirmPay() {
				let that=this;
				let _openid = localStorage.getItem("_openid")
				that.preConfirm=false;
				this.$axios.post(that.$DOMAIN() + "/wechatApi/payease/confirmOrder", {
						"requestRefNo": this.requestRefNo,
						"kaptchaCode": this.form.smscode,
					}, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						console.log("ret===>",response.data.result)
						if (response.data.result == "FAIL") {
							that.preConfirm=true;
							that.toast(response.data.failReason)
							return
						} else {
							that.timeOut = 0;
							that.waitTimer = setInterval(function() {
								that.waitResult(response.data.requestNo)
							}, 3000);
						}
					})
					.catch(function(error) {
						that.toast(error.response.data.errmsg)
				});
			},
			
			
			preConfirmPay() {
				this.totalRepay = 0;
				this.netRepay = 0;
				let that = this;
				for (var t = 0; t < this.LoanList.length; t++) {
					if (this.repayInput[t] * 1 > this.LoanList[t].totalRepyaAmount / 100) {
						this.toast(this.LoanList[t].loanContractNo + " 还款金额不能大于应还金额")
						return
					}
					if (!isNaN(this.repayInput[t])) {
						this.totalRepay = this.totalRepay + this.repayInput[t] * 100
					}
				}

				if (this.totalRepay < 1000 || this.totalRepay > 999900) {
					this.toast("总的还款金额要介于10.00到9999.00元之间")
					return
				}

				//this.netRepay = this.totalRepay - this.reductAmt
				//this.netRepay=Math.round(this.netRepay)

				let productType = ""
				this.openid = localStorage.getItem("_openid")
				let loanList = [];
				let isReduct = false
				for (var tt = 0; tt < this.LoanList.length; tt++) {
					if (!isNaN(this.repayInput[tt] * 1)) {
						let repayAmt = this.repayInput[tt] * 100;
						//如果还没减免
						if (!isReduct) {
							if(repayAmt>this.reductAmt){
								repayAmt = repayAmt - this.reductAmt
								isReduct = true;
							}
						}
						
						repayAmt=Math.round(repayAmt)
						
						this.netRepay=this.netRepay+repayAmt
						
						if (this.LoanList[tt].productNo == 'LIFE0001') {
							loanList.push({
								"contractNo": this.LoanList[tt].loanContractNo,
								"repayAmt": repayAmt,
								"product": "shd"
							})
						} else {
							loanList.push({
								"contractNo": this.LoanList[tt].loanContractNo,
								"repayAmt": repayAmt,
								"product": "xfd"
							})
						}
					}
				}
				let shdCount = 0;
				let xfdCount = 0;
				//生活贷笔数
				for (var i = 0; i < that.LoanList.length; i++) {
					if (!isNaN(this.repayInput[i] * 1)) {
						if (that.LoanList[i].productNo === 'LIFE0001') {
							shdCount = shdCount + 1
						}
					}
				}
				//消费贷笔数
				for (var j = 0; j < that.LoanList.length; j++) {
					if (!isNaN(this.repayInput[j] * 1)) {
						if (that.LoanList[j].productNo != 'LIFE0001') {
							xfdCount = xfdCount + 1
						}
					}
				}
				if (xfdCount > 0 && shdCount > 0) {
					productType = "xfd,shd"
				} else {
					if (xfdCount > 0) {
						productType = "xfd"
					}
					if (shdCount > 0) {
						productType = "shd"
					}
				}
				
				let _repayInfo = {
					"repayInfo": loanList,
					"userId": that.crfUid,
					"linkId": that.form.linkId,
					"productType": productType,
					"transferAmount": that.netRepay,
					"channelNo": "SHYPay",
					"reductAmt": that.reductAmt,
					"fundSource":that.fundSource,
				};
				
				that.repayInfo = _repayInfo;
				that.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/finalAmt/" + that.crfUid, {
						headers: {
							'openId': this.openid
						}
					})
					.then(function(response) {
						if (response.data.status == 1) {
							const h = that.$createElement
							const messageVNode = h('div', {
								class: ['foobar']
							}, [
								h('p', {
									class: ['text-center']
								}, [
									"你曾在" + response.data.payTime + "发起支付" ,
									h('strong', that.formatCurrency((response.data.payAmt + response.data.reductAmt) / 100 )),
									' 元，实际支付',
									h('strong', that.formatCurrency((response.data.payAmt / 100))),
									' 元，是否继续支付？'
								]),
							])
							that.$bvModal.msgBoxConfirm(messageVNode, {
									title: '支付确认',
									size: 'md',
									buttonSize: 'md',
									okVariant: 'success',
									okTitle: '确认',
									cancelTitle: '取消',
									footerClass: 'p-2',
									hideHeaderClose: false,
									centered: true
								})
								.then(value => {
									if (value) {
										that.goPay()
									}
								})
								.catch(err => {
									console.log(err)
								})
						} else {
							that.goPay()
						}
					})
					.catch(function(error) {
						console.log(error)
					});
			},
		}
	}
</script>

<style>

</style>
